import createReactClass from "create-react-class";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import {
  AutoSizer,
  Column,
  SortDirection,
  SortIndicator,
  Table,
} from "react-virtualized";
import { AdminActions } from "../../actions/adminActions";
import { ServerActions } from "../../actions/serverActions";
import { adminStore } from "../../stores/adminStore";
import { subdivisionStore } from "../../stores/subdivision";
import { ContentBox } from "./ContentBox";

import "../../css/adminScreen.css";
import { withRouter } from "../../util/withRouter";

var successMsg = "";

// Load state from the stores
function getStateFromStores() {
  return {
    itemType: adminStore.getItemType(),
    isLoading: adminStore.isLoading(),
    items: adminStore.getItems(),
    loadingError: adminStore.getError(),
    subdivisions: subdivisionStore.getEntireSubList(),
    disableHeader: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    sortBy: "name",
    sortDirection: SortDirection.ASC,
    filteredData: adminStore.getItems(),
    bNumber: "",
    distributionEmail: "",
    oldbNumber: "",
    olddistributionEmail: "",
    defaultID: 0,
    oldIsAdmin: false,
    alertVisible: false,
    alertMessage: "",
    defaultChecked: true,
  };
}

 const UserAdminComponent = createReactClass({
  componentDidMount: function () {
    $("#mainSchematic").empty();
    adminStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    AdminActions.setItemType(this.props.location.pathname);
    AdminActions.loadItems();
    ServerActions.getSubdivisionList();
  },

  componentWillUnmount: function () {
    adminStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  refresh: function () {
    this.setState({});
  },
  // Sort function for the default track data table
  _sort({ sortBy, sortDirection }) {
    const comparer = (a, b) => {
      if (sortBy == "distributionEmail") {
        if (sortDirection === "ASC") {
          return (a[sortBy] == null ? "" : a[sortBy])
            .toString()
            .toUpperCase()
            .trim() >
            (b[sortBy] == null ? "" : b[sortBy]).toString().toUpperCase().trim()
            ? 1
            : -1;
        } else if (sortDirection === "DESC") {
          return (a[sortBy] == null ? "" : a[sortBy])
            .toString()
            .toUpperCase()
            .trim() <
            (b[sortBy] == null ? "" : b[sortBy]).toString().toUpperCase().trim()
            ? 1
            : -1;
        }
      } else {
        if (sortDirection === "ASC") {
          return (a[sortBy] + "").toString().toUpperCase().trim() >
            (b[sortBy] + "").toString().toUpperCase().trim()
            ? 1
            : -1;
        } else if (sortDirection === "DESC") {
          return (a[sortBy] + "").toString().toUpperCase().trim() <
            (b[sortBy] + "").toString().toUpperCase().trim()
            ? 1
            : -1;
        }
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.state.originalRows.slice(0)
        : this.state.filteredData.sort(comparer);

    this.setState({ rows });
    this.setState({ sortBy, sortDirection });
  },

  _rowClassName({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },
  _noRowsRenderer() {
    return <div className="noRows">No rows found</div>;
  },
  _onRowCountChange(event) {
    const rowCount = parseInt(event.target.value, 10) || 0;

    this.setState({ rowCount });
  },

  _getDatum(list, index) {
    return list.get(index % list.size);
  },

  _onScrollToRowChange(event) {
    const { rowCount } = this.state;
    let scrollToIndex = Math.min(
      rowCount - 1,
      parseInt(event.target.value, 10)
    );

    if (isNaN(scrollToIndex)) {
      scrollToIndex = undefined;
    }

    this.setState({ scrollToIndex });
  },

  _getRowHeight({ index }) {
    const { list } = this.context;
    return this._getDatum(list, index).size;
  },

  // Filter the records form the Default track table
  _filterRecordsOfTheTable(value) {
    var dataSet = this.state.items;
    dataSet = dataSet.filter(function (item) {
      if (
        (item.bNumber || "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.userName || "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.distributionEmail || "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        item.getPtcVerificationEmail
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        item.getSlsPageEmail
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        item.getOverrideEmail
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        item.canGrantOverride
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1
      ) {
        return true;
      }
    });
    this.setState({ filteredData: dataSet });
  },

  _headerRenderer({ dataKey, sortBy, sortDirection }) {
    return (
      <div>
        Display Order
        {sortBy === dataKey && <SortIndicator sortDirection={sortDirection} />}
      </div>
    );
  },

  saveNotificationRecord: function () {
    var state = this.state;
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var isErrorExist = false;
    if (state.bNumber.length < 7 && state.bNumber != "") {
      this.setState({ alertVisible: true });
      this.setState({
        alertMessage: "BID should be defaulted to 8 characters",
      });
      isErrorExist = true;
    } else if (
      state.bNumber.length >= 7 &&
      state.defaultID == "" &&
      state.bNumber.toUpperCase() != "DISTRIB"
    ) {
      for (var i = 0; i < this.state.items.length; i++) {
        if (
          state.bNumber.toUpperCase() ==
          this.state.items[i].bNumber.toUpperCase()
        ) {
          this.setState({ alertVisible: true });
          this.setState({
            alertMessage: "The Bnumber " + state.bNumber + " already exists",
          });
          isErrorExist = true;
          break;
        }
      }
    } else if (!regex.test(state.distributionEmail) && state.bNumber == "") {
      this.setState({ alertVisible: true });
      this.setState({
        alertMessage: "Please enter a valid B Number or  Email Id",
      });
      isErrorExist = true;
    } else if (
      regex.test(state.distributionEmail) &&
      state.bNumber == "DISTRIB" &&
      state.defaultID == ""
    ) {
      for (var i = 0; i < this.state.items.length; i++) {
        if (
          this.state.items[i].distributionEmail != null &&
          state.distributionEmail.toUpperCase() ==
          this.state.items[i].distributionEmail.toUpperCase()
        ) {
          this.setState({ alertVisible: true });
          this.setState({
            alertMessage:
              "The Email " + state.distributionEmail + " already exists",
          });
          isErrorExist = true;
          break;
        }
      }
    }
    if (!isErrorExist) {
      AdminActions.submitNewGritUser({
        bNumber: state.bNumber,
        distributionEmail:
          state.distributionEmail == null ? "" : state.distributionEmail,
        oldbNumber: state.oldbNumber,
        olddistributionEmail: state.olddistributionEmail,
        getPtcVerificationEmail: $("#ptcVerification").prop("checked"),
        getSlsPageEmail: $("#slsPageCheck").prop("checked"),
        getOverrideEmail: $("#overrideNotification").prop("checked"),
        canGrantOverride: $("#grantOverride").prop("checked"),
        defaultID: state.defaultID,
        oldIsAdmin: state.oldIsAdmin,
      });
      setTimeout(
        function () {
          AdminActions.loadItems();
          items: adminStore.getItems();
          var dataSet = this.state.items;
          this.setState({ filteredData: dataSet });
          this.setState({
            oldbNumber: "",
            olddistributionEmail: "",
            bNumber: "",
            distributionEmail: "",
            defaultID: "",
          });
          $("#bNumber").attr("readOnly", false);
          $("#distributionEmail").attr("readonly", false);
          $("input:checkbox").removeAttr("checked");
          var successUser = state.bNumber;
          if (state.bNumber == "DISTRIB") {
            successUser = state.distributionEmail;
          }
          var msg = state.defaultID == 0 ? "saved" : "updated";
          successMsg = (
            <label className="informationRequestInfoItem">
              User {successUser.toString()} {msg} successfully{" "}
            </label>
          );
        }.bind(this),
        150
      );
    }
  },
  deleteUserDetail: function () {
    var state = this.state;
    var successUser = state.bNumber;
    if (state.defaultID == "") {
      this.setState({ alertVisible: true });
      this.setState({ alertMessage: "Please select a row to delete" });
    } else {
      window
        .confirm("Confirm Delete", {
          description: "Are you sure you want to delete the selected user ?",
          confirmLabel: "Delete",
          abortLabel: "Go Back",
        })
        .then(function () {
          AdminActions.deleteGritUserDetail(state.bNumber);
          setTimeout(
            function () {
              AdminActions.loadItems();
              items: adminStore.getItems();
              var dataSet = this.state.items;

              if (state.bNumber == "DISTRIB") {
                successUser = state.distributionEmail;
              }
              successMsg = (
                <label className="informationRequestInfoItem">
                  User {successUser.toString()} deleted successfully{" "}
                </label>
              );
              $("input:checkbox").removeAttr("checked");
              this.setState({ filteredData: dataSet });
            }.bind(this),
            150
          );
        });
    }
  },
  // clear selected track
  clearSelectedNotification: function () {
    $("input:checkbox").removeAttr("checked");
    $("input[value=active]").prop("checked", true);
    successMsg = "";
    this.setState({
      oldbNumber: "",
      olddistributionEmail: "",
      bNumber: "",
      distributionEmail: "",
      defaultID: "",
    });
    $("#bNumber").attr("readOnly", false);
    $("#distributionEmail").attr("readonly", false);
  },
  handleAlertDismiss() {
    this.setState({ alertVisible: false });
  },

  _onRowClick({ rowData }) {
    this.setState({ olddistributionEmail: rowData.distributionEmail });
    this.setState({ oldbNumber: rowData.bNumber });
    this.setState({
      bNumber: rowData.bNumber,
      distributionEmail: rowData.distributionEmail,
      defaultID: rowData.id,
      oldIsAdmin: rowData.isAdmin,
    });
    successMsg = "";
    $("input[value=slsPageCheck]").prop("checked", rowData.getSlsPageEmail);
    $("input[value=ptcVerification]").prop(
      "checked",
      rowData.getPtcVerificationEmail
    );
    $("input[value=overrideNotification]").prop(
      "checked",
      rowData.getOverrideEmail
    );
    $("input[value=grantOverride]").prop("checked", rowData.canGrantOverride);
  },

  onChange: function (event) {
    if (event.target) {
      if (event.target.id === "distributionEmail") {
        this.setState({ distributionEmail: event.target.value });
      } else if (event.target.id === "bNumber") {
        this.setState({ bNumber: event.target.value });
      }
    }
  },

  fnbNumberUpdate: function (event) {
    //when the BID/CID is not 7 and the value is not cleared
    if (event.target.value.length < 7 && event.target.value != "") {
      this.setState({ alertVisible: true });
      this.setState({
        alertMessage: "BID should be defaulted to 8 characters",
      });
      $("#distributionEmail").attr("readonly", true);
    } else if (event.target.value == "") {
      $("#distributionEmail").attr("readonly", false);
      if ($("#distributionEmail").val() != "") {
        this.setState({ bNumber: "DISTRIB" });
      }
    } else {
      var regex = /^[a-z0-9]+$/i;
      if (!regex.test(event.target.value)) {
        this.setState({ alertVisible: true });
        this.setState({
          alertMessage: "Please enter a valid BID without special characters.",
        });
      } else {
        if (this.state.defaultID == "" && event.target.value != "DISTRIB") {
          this.setState({ distributionEmail: "" });
          $("#distributionEmail").attr("readonly", true);
        }
      }
    }
  },

  fnDistributionMailUpdate: function (event) {
    //To check if its a valid E-mail address
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (regex.test(event.target.value)) {
      //Defaulting the bNumber to DISTRIB
      $("#bNumber").val("DISTRIB");
      $("#bNumber").attr("readonly", true);
      this.setState({ bNumber: "DISTRIB" });
      this.setState({ distributionEmail: event.target.value });
      //Uncheck the flags if its already been checked
      $("input[value=slsPageCheck]").prop("checked", false);
      $("input[value=ptcVerification]").prop("checked", false);
    } else if (event.target.value == "") {
      //If the values is been cleared, remove the error field and the disabled properties.
      $("#bNumber").attr("readonly", false);
      if (this.state.bNumber == "DISTRIB") {
        this.setState({ bNumber: "" });
      }
    } else {
      //If the mail Id criteria is not satisfied add the error message
      this.setState({ alertVisible: true });
      this.setState({ alertMessage: "Please enter a valid E-Mail Id" });
      $("#bNumber").attr("readonly", false);
      $("#bNumber").val("");
    }
  },

  radioOnChange: function (event) {
    if (event.target.id == "formAReasonCode") {
      if ($("#formAReasonCode").prop("checked") == true) {
        $("input[value=FormB]").prop("checked", false);
        $("input[value=FormAReject]").prop("checked", false);
        $("input[value=FormBReject]").prop("checked", false);
        $("input[value=override]").prop("checked", false);
      }
    }
  },

  checkDistributionEmail({ cellData }) {
    if (cellData == null) {
      return "";
    } else {
      return cellData;
    }
  },

  render: function () {
    var errorMsg = "";
    var searchBox = (
      <div id="accordion" className="ui-widget-TableHeader">
        {successMsg}
        <span>
          <b> Search: </b>
        </span>
        <input
          type="text"
          onChange={(event) =>
            this._filterRecordsOfTheTable(event.target.value)
          }
        />
      </div>
    );
    if (this.state.alertVisible) {
      errorMsg = (
        <Modal
          bsSize="large"
          dialogClassName="errorModal"
          onHide={this.handleAlertDismiss}
          show={this.state.alertVisible}
        >
          <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
          </Modal.Header>

          <div className="modal-body">{this.state.alertMessage}</div>
          <div className="modal-footer">
            <Button id="cancelConfirmButton" onClick={this.handleAlertDismiss}>
              OK
            </Button>
          </div>
        </Modal>
      );
    }
    var bNumVal = this.state.bNumber;
    var distributionEmailVal =
      this.state.distributionEmail == null ? "" : this.state.distributionEmail;

    var bNo = (
      <div className="addEditTopRow">
        <label>*B Number:</label>
      </div>
    );
    var bNumberDiv = (
      <div className="addEditTopRow">
        <input
          type="text"
          id="bNumber"
          className="mpInput"
          name="B Number"
          maxLength="8"
          style={{ width: "125px" }}
          value={bNumVal}
          onChange={this.onChange}
          onBlur={this.fnbNumberUpdate}
          required
        />
      </div>
    );
    var distributionEmailLabel = (
      <div className="addEditTopRow">
        <label>*Distribution Email:</label>
      </div>
    );
    var distributionEmailInput = (
      <div className="addEditTopRow">
        <input
          type="text"
          id="distributionEmail"
          className="mpInput"
          name="Distribution Email"
          maxLength="40"
          value={distributionEmailVal}
          style={{ width: "175px" }}
          readOnly={false}
          onChange={this.onChange}
          onBlur={this.fnDistributionMailUpdate}
          required
        />
      </div>
    );
    var ptcVerificationCheckbox = (
      <div>
        <label>
          <b>Ptc Verification:</b>{" "}
          <input
            type="checkbox"
            id="ptcVerification"
            name="ptcVerification"
            value="ptcVerification"
          />
        </label>
      </div>
    );
    var slsPageCheckbox = (
      <div>
        <label>
          <b>Sls Page: </b>
          <input
            type="checkbox"
            id="slsPageCheck"
            name="slsPageCheck"
            onChange={this.radioOnChange}
            value="slsPageCheck"
          />
        </label>
      </div>
    );
    var overrideNotificationCheckbox = (
      <div>
        <label>
          <b>Override Notification: </b>
          <input
            type="checkbox"
            id="overrideNotification"
            name="overrideNotification"
            onChange={this.radioOnChange}
            value="overrideNotification"
          />
        </label>
      </div>
    );
    var grantOverrideCheckbox = (
      <div>
        <label>
          <b>Can Grant Override: </b>
          <input
            type="checkbox"
            id="grantOverride"
            name="grantOverride"
            onChange={this.radioOnChange}
            value="grantOverride"
          />
        </label>
      </div>
    );
    var addButton = (
      <div>
        <Button
          bsStyle="primary adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.saveNotificationRecord}
        >
          Save
        </Button>
      </div>
    );

    var clearButton = (
      <div>
        <Button
          bsStyle="primary adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.clearSelectedNotification}
        >
          Clear
        </Button>
      </div>
    );

    var deleteButton = (
      <div>
        <Button
          bsStyle="danger adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.deleteUserDetail}
        >
          Delete
        </Button>
      </div>
    );

    const {
      disableHeader,
      scrollToIndex,
      rowHeight,
      headerHeight,
      overscanRowCount,
      sortBy,
      sortDirection,
    } = this.state;

    var content = "Loading....";

    if (this.state.isLoading) {
      content = "Loading....";
    } else {
      if (screen.height <= 768) {
        var hig = "53vh";
      } else {
        var hig = "68vh";
      }
      if (this.state.itemType == "/gritUser") {
        var list = this.state.filteredData;
        content = (
          <div style={{ height: "100%" }}>
            <table width="100%">
              <tr>
                <td width="2%"></td>
                <td width="96%">
                  <div className="screenHeader">
                    <b>Email Notifications</b>
                  </div>
                  <div id="accordion" className="ui-widget-header">
                    <h5>
                      <b>ADD/EDIT RECORD</b>
                    </h5>
                  </div>
                  <div id="controlLayoutGrid" role="main">
                    <table id="headers" width="100%;">
                      <thead>
                        <tr>
                          <th align="center" width="2%;" />
                          <th align="center" width="7%;">
                            {bNo}
                          </th>
                          <th align="center" width="8%;">
                            {bNumberDiv}
                          </th>
                          <th align="center" width="12%;">
                            {distributionEmailLabel}
                          </th>
                          <th id="th4" width="15%;">
                            {distributionEmailInput}
                          </th>
                          <th align="center" width="13%">
                            {ptcVerificationCheckbox}
                          </th>
                          <th align="center" width="9%">
                            {slsPageCheckbox}
                          </th>
                          <th align="center" width="15%">
                            {overrideNotificationCheckbox}
                          </th>
                          <th align="center" width="9%">
                            {grantOverrideCheckbox}
                          </th>
                          <th align="center" width="2%;" />
                        </tr>
                      </thead>
                    </table>
                    <table id="footers" width="100%;">
                      <thead>
                        <tr>
                          <th align="center" width="40%;" />
                          <th align="center" width="6%;">
                            {addButton}
                          </th>
                          <th align="center" width="6%;">
                            {clearButton}
                          </th>
                          <th align="center" width="6%;">
                            {deleteButton}
                          </th>
                          <th align="center" width="40%;" />
                        </tr>
                      </thead>
                    </table>
                  </div>
                </td>
                <td width="2%"></td>
              </tr>
              <tr>
                <td width="2%"></td>
                <td width="96%">
                  {searchBox}
                  <ContentBox className="currentSchematic">
                    <div style={{ height: hig }}>
                      <AutoSizer>
                        {({ height, width }) => (
                          <Table
                            ref="Table"
                            disableHeader={disableHeader}
                            headerClassName="headerColumn"
                            scrollToIndex={scrollToIndex}
                            width={width}
                            height={height}
                            headerHeight={headerHeight}
                            overscanRowCount={overscanRowCount}
                            rowHeight={rowHeight}
                            rowCount={list.length}
                            rowClassName={this._rowClassName}
                            noRowsRenderer={this._noRowsRenderer}
                            sort={this._sort}
                            sortBy={sortBy}
                            sortDirection={sortDirection}
                            onRowDoubleClick={this._onRowClick}
                            rowGetter={({ index }) => list[index]}
                          >
                            <Column
                              width={width * 0.2}
                              minWidth={10}
                              label="BNumber"
                              dataKey="bNumber" /*cellRenderer={this.checkActiveOrDeactive}*/
                            />
                            <Column
                              width={width * 0.2}
                              minWidth={50}
                              label="Name"
                              dataKey="userName" /*cellRenderer={this.checkActiveOrDeactive}*/
                            />
                            <Column
                              width={width * 0.35}
                              minWidth={50}
                              label="Distribution Email"
                              dataKey="distributionEmail"
                              cellRenderer={this.checkDistributionEmail}
                            />
                            <Column
                              width={width * 0.3}
                              minWidth={50}
                              label="PTC Verification"
                              dataKey="getPtcVerificationEmail"
                            />
                            <Column
                              width={width * 0.12}
                              minWidth={10}
                              label="Sls Page"
                              dataKey="getSlsPageEmail" /*cellRenderer={this.checkReasonType}*/
                            />
                            <Column
                              width={width * 0.38}
                              minWidth={50}
                              label="Override Notification"
                              dataKey="getOverrideEmail"
                            />
                            <Column
                              width={width * 0.35}
                              minWidth={50}
                              label="Can Grant Override"
                              dataKey="canGrantOverride"
                            />
                          </Table>
                        )}
                      </AutoSizer>
                    </div>
                  </ContentBox>
                  <div id="accordion" className="ui-widget-TableFooter">
                    {" "}
                  </div>
                </td>
                <td width="2%"></td>
              </tr>
            </table>
          </div>
        );
      }
    }

    return (
      <div className="positionUnderHeader" style={{ height: "100%" }}>
        {content}
        {errorMsg}
      </div>
    );
  },
});

export const UserAdmin = withRouter(UserAdminComponent);
